import React, {type CSSProperties} from 'react';

interface IButtonGroupProps {
    children: React.ReactNode | React.ReactNode[] | undefined;
    style: Partial<Pick<CSSProperties, 'justifyContent' | 'gap'>>;
}

/**
 * @deprecated Ticket #589.
 */
export default function CButtonGroup(props: IButtonGroupProps) {
    return (<div className={'flex flex-col md:flex-row gap-4'} style={props.style}>
        {props.children}
    </div>);
}